import { useMutation } from "@/compat/reactQuery";
import actionService from "../../services/actionService";

const useAddActionComment = () => useMutation(actionService.addActionComment)

export default useAddActionComment;